import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
// src/mixins/etc.ts
import { css } from "styled-components";
var noTextInteraction = function noTextInteraction() {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    text-decoration: none;\n    outline: none;\n    user-select: none;\n\n    &:hover,\n    &:focus,\n    &:active,\n    &:visited {\n        text-decoration: none;\n    }\n"])));
};
var reset = function reset() {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    text-align: left;\n    margin: 0;\n    padding: 0;\n    word-break: normal;\n    overflow-wrap: normal;\n    white-space: normal;\n"])));
};
var buttonReset = function buttonReset() {
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    appearance: none;\n    border: none;\n    background-color: transparent;\n    border-radius: 0;\n    display: block;\n    cursor: pointer;\n    padding: 0;\n\n    &[disabled] {\n        cursor: default;\n    }\n"])));
};
var zIndex = function zIndex(_ref) {
  var zIndexValue = _ref.zIndex;
  return zIndex !== void 0 ? css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n              z-index: ", ";\n          "])), zIndexValue) : "";
};
var notLastChild = function notLastChild() {
  return ":not(:last-child)";
};
var childrenNotLastChild = function childrenNotLastChild() {
  return "> *".concat(notLastChild());
};
var round = function round() {
  return "border-radius: 9999px;";
};
var textDecorationNone = function textDecorationNone() {
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    text-decoration: none;\n    &:hover,\n    &:visited,\n    &:active,\n    &:focus {\n        text-decoration: none;\n    }\n"])));
};
var enforceColor = function enforceColor(color) {
  return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    color: ", ";\n    &:hover,\n    &:visited,\n    &:active,\n    &:focus {\n        color: ", ";\n    }\n"])), color, color);
};
export { noTextInteraction, reset, buttonReset, zIndex, notLastChild, childrenNotLastChild, round, textDecorationNone, enforceColor };